import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ItemPropertyModel } from '../models/item-property-model';
import { ItemPropertiesService } from '../item-properties.service';
import { ItemsService } from '../items.service';

@Component({
    selector: 'edit-item-property',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    providers: [ItemsService],
    templateUrl: './edit-item-property.component.html',
    styleUrls: ['./edit-item-property.component.css']
})
export class EditItemPropertyComponent implements OnInit {
    @Input() itemProperty: ItemPropertyModel;
    @Input() isNewProperty: boolean = false;
    @Input() itemId: string;

    public model: ItemPropertyModel;

    constructor(
        public activeModal: NgbActiveModal,
        private itemPropertiesService: ItemPropertiesService
    ) {}

    ngOnInit(): void {
        if (this.isNewProperty) {
            const now = new Date();
            const formattedDate = now.toISOString().slice(0, 19); // "yyyy-MM-ddTHH:mm:ss"

            this.model = {
                itemId: this.itemId,
                key: '',
                value: '',
                type: '',
                originSource: 'ADMINTOOL',
                publishingSource: 'ADMINTOOL',
                taxonomyNodeId: '',
                createdDateTime: formattedDate,
                updateDateTime: formattedDate
            };
        } else {
            // Create a copy to avoid modifying the original
            this.model = { ...this.itemProperty };
        }
    }

    public save() {
        if (this.isNewProperty) {
            // Create new property
            this.itemPropertiesService.createItemProperty(this.model).subscribe(
                {
                    next: (result) => {
                        this.activeModal.close({ action: 'save', data: result });
                    },
                    error: (error) => {
                        console.error('Error creating item property:', error);
                        alert('Failed to create the property. Please try again.');
                    }
                }
            );
        } else {
            // Update existing property
            this.itemPropertiesService.updateItemProperty(this.model).subscribe(
                {
                    next: (result) => {
                        this.activeModal.close({ action: 'save', data: result });
                    },
                    error: (error) => {
                        console.error('Error updating item property:', error);
                        alert('Failed to update the property. Please try again.');
                    }
                }
            );
        }
    }
    
    public cancel() {
        this.activeModal.dismiss('cancel');
    }

    // private getRequestModel(formGroup: FormGroup) {
    //     let parserClass: ParserClass = new ParserClass();
    //     parserClass.id = formGroup.value.id;
    //     parserClass.parser = formGroup.value.parser;
    //     parserClass.description = formGroup.value.description;
    //     return parserClass;
    // }
}
